<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » QRコード生成結果の説明
  </div>
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>QRコード生成結果の説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_qrcode-result.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> QRコード・フォントサイズの設定
        </div>
        <div class="manual-explain">
          QRコードのサイズ、一緒に印字される展示ID、展示名称のフォントサイズを設定します。<br>
          ※サイズは任意に設定可能ですが、プリセットもいくつか用意されています。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 印刷ボタン
        </div>
        <div class="manual-explain">
          クリックすることで表示されているQRコードを印刷します。<br>
          ※印刷ダイアログが表示されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> QRコード一覧
        </div>
        <div class="manual-explain">
          生成画面で選択されたフロア・展示ページURLのQRコードの一覧が表示されます。<br>
          生成画面で言語選択をした場合は言語ごとのQRコードが追加表示されます。<br>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of QR Code Generation Results
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of QR Code Generation Results</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_qrcode-result.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> QR Code and Font Size Settings
        </div>
        <div class="manual-explain">
          Configure the size of the QR code and the font size of the exhibit ID and exhibit name printed alongside it.<br>
          * Sizes can be set freely, but several presets are also available.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Print Button
        </div>
        <div class="manual-explain">
          Clicking this button prints the displayed QR codes.<br>
          * A print dialog will appear.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> QR Code List
        </div>
        <div class="manual-explain">
          Displays a list of QR codes for the floor and exhibit page URLs selected in the generation screen.<br>
          If languages were selected in the generation screen, QR codes for each language will also be displayed.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
